import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import OcrActivityContent from "modules/OcrActivity";

import React from "react";

import { setTitle } from "utilities/helper/setTitle";

const OcrActivityPage: React.FC = () => {
  setTitle("OCR Activity");
  return (
    <Auth>
      <Layout>
        <OcrActivityContent />
      </Layout>
    </Auth>
  );
};

export default OcrActivityPage;
